var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_vm._t("default"),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"loading"},[_c('img',{attrs:{"src":require("@/assets/loader/oval.svg")}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }